import React from "react";

export interface QuestionnaireTypeProps {
	questionnaireType: string;
}

const WithQuestionnaireType: React.FC<QuestionnaireTypeProps> = ({questionnaireType, children}) => {
	const childElements = React.Children.map(children, (child) => React.cloneElement(child as React.ReactElement<QuestionnaireTypeProps>, {questionnaireType: questionnaireType}));
	return <>{childElements}</>;
};

export default WithQuestionnaireType;
